// reducers/pubsub/index.js

import { combineReducers }   from 'redux';
import { list }              from './list';
import { listHasErrored }    from './list';
import { listIsLoading }     from './list';
import { add }               from './add';
import { addHasErrored }     from './add';
import { addIsLoading }      from './add';
import { remove }            from './remove';
import { removeHasErrored }  from './remove';
import { removeIsLoading }   from './remove';
import { disable }           from './disable';
import { disableHasErrored } from './disable';
import { disableIsLoading }  from './disable';
import { execute }           from './execute';
import { executeHasErrored } from './execute';
import { executeIsLoading }  from './execute';
import { process }           from './process';
import { processHasErrored } from './process';
import { processIsLoading }  from './process';
import { inputs }            from './inputs';
import { inputsHasErrored }  from './inputs';
import { inputsIsLoading }   from './inputs';

const listReducers = combineReducers({
  list,
  listHasErrored,
  listIsLoading
});

const addReducers = combineReducers({
  add,
  addHasErrored,
  addIsLoading
});

const removeReducers = combineReducers({
  remove,
  removeHasErrored,
  removeIsLoading
});

const disableReducers = combineReducers({
  disable,
  disableHasErrored,
  disableIsLoading
});

const executeReducers = combineReducers({
  execute,
  executeHasErrored,
  executeIsLoading
});

const processReducers = combineReducers({
  process,
  processHasErrored,
  processIsLoading
});

const inputsReducers = combineReducers({
  inputs,
  inputsHasErrored,
  inputsIsLoading
});

export default combineReducers({
  list:    listReducers,
  add:     addReducers,
  remove:  removeReducers,
  disable: disableReducers,
  execute: executeReducers,
  process: processReducers,
  inputs:  inputsReducers
});